const getters = {
  regionId: (state: any) => state.settings.regionId,
  background: (state: any) => state.settings.background,
  contactNumber: (state: any) => state.settings.contactNumber,
  address: (state: any) => state.settings.address,
  faceIcon: (state: any) => state.settings.faceIcon,
  link: (state: any) => state.settings.link,
  businessHours: (state: any) => state.settings.businessHours,
  isShowNav: (state: any) => state.settings.isShowNav,
  homeMapColor: (state: any) => state.settings.homeMapColor,
  homeMapUrl: (state: any) => state.settings.homeMapUrl,
  roomMapColor: (state: any) => state.settings.roomMapColor,
  roomMapUrl: (state: any) => state.settings.roomMapUrl,
  shareIcon: (state: any) => state.settings.shareIcon,
  title: (state: any) => state.settings.title,
  shareTitle: (state: any) => state.settings.shareTitle
};

export default getters;
